import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { DscTituloPaginator, iconVer, openModalMensaje, saveContent, strMatTablePaginator } from 'src/app/general/variables';
import { EstadoAlertaMovil } from 'src/app/models/EstadoAlertaMovil';
import { Fur } from 'src/app/models/Fur';
import { LoginMovil } from 'src/app/models/LoginMovil';
import { MailDetalle } from 'src/app/models/MailDetalle';
import { FurService } from 'src/app/services/fur.service';
import { ModalDetalleMovilComponent } from './modal-detalle-movil/modal-detalle-movil.component';

@Component({
  selector: 'app-datos-movil',
  templateUrl: './datos-movil.component.html',
  styleUrls: ['./datos-movil.component.css']
})
export class DatosMovilComponent implements OnInit {

  furRecup: Fur = null;
  loginMovil: LoginMovil = null;
  strNroRegistro: string = null;
  strFechaReg: string = null;
  strDscDenunciante: string = null;
  strBase64: string = null;
  iconVer = iconVer;
  strMatTablePaginator = strMatTablePaginator;
  listaEstadoAlerta: EstadoAlertaMovil[] = [];
  dataSource: MatTableDataSource<EstadoAlertaMovil>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  matTableColumnsDef = ['item', 'descripcion', 'acciones'];
  matTableColumnsEtiq = ['Ítem', 'Descripción', 'Detalle'];

  constructor(protected furService: FurService,
              public dialog: MatDialog,

     ) { }

  ngOnInit() {



  }

  cargarDatosMovil() {

    this.loginMovil = new LoginMovil();

    this.loginMovil.cfurCodigoBorrador = this.furRecup.cfurCodborrador;
    // this.loginMovil.cfurClavedenunc = this.furRecup.cfurClavedenunc;
    this.loginMovil.strFlgOlvidoClave = '04';

    this.furService.obtenerFurPorLoginMovil(this.loginMovil).subscribe(

      data => {


        if (data == null) {

          openModalMensaje('Atención de Denuncias', 'Error al procesar datos del móvil, por favor verifique', this.dialog);

          return;

        } else {
          console.log('=== obtenerFurPorLoginMovil this.furRecup');
          console.log(this.furRecup);

          this.strDscDenunciante = data.strDscNomComplDenciante;
          this.strFechaReg = data.strDfurFecregistroSoloFecha;
          this.strNroRegistro = this.furRecup.cfurCodborrador;
          this.strBase64 = data.strBase64Doc;

          this.listaEstadoAlerta = data.listaEstadoAlerta;

          this._resetMatTable();

        }

      }
      ,
      err => {


        console.log(err);

        openModalMensaje('Atención de Denuncias', 'Inconvenientes con el servicio de Login Movil', this.dialog);

        return;

      }
      );


  }

  setFurRecupDatosMovil(fur: Fur) {

    this.furRecup = fur;

  }

  _descargarDocumento() {

    // saveContent("data:application/pdf;base64," + this.strBase64,"Documento.pdf");
    saveContent(this.strBase64, 'Documento.pdf');
    // saveContent( this.strBase64,"Documento.pdf");

  }


  _resetMatTable() {

    if (this.listaEstadoAlerta) {

      setTimeout(() => {

        this.dataSource = new MatTableDataSource(this.listaEstadoAlerta);

        if (this.paginator != null) {this.paginator._intl.itemsPerPageLabel = DscTituloPaginator; }

        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

      }, 1);

    }

  }

  _verDetalle(row: EstadoAlertaMovil) {

    this.dialog.open( ModalDetalleMovilComponent, { width: '80%', height: '87%', data: {listaSeguimiento : row.listaSeguimiento}});

  }

}
